<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商编号</label>
            <em class="weui-form-preview__value">{{form.main.cu_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="cu_name">
            <label class="weui-form-preview__label">{{customLabel.cu_name || "代理商名称"}}</label>
            <div class="weui-form-preview__value weui-form-preview__value-icon">
              <span>{{form.main.cu_name}}</span>
              <router-link :to="{path:'/ent/Information',query:{name:form.main.cu_name}}" class="iconfont icon-qichacha"></router-link>
            </div>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_nsrzh" slot="cu_nsrzh">
            <label class="weui-form-preview__label">{{customLabel.cu_nsrzh || "社会信用代码"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_nsrzh}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_agentlevel">
            <label class="weui-form-preview__label">{{customLabel.cu_agentlevel || "代理商等级"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_agentlevel}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_proddesc">
            <label class="weui-form-preview__label">{{customLabel.cu_proddesc || "代理产品种类"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_proddesc}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_type">
            <label class="weui-form-preview__label">{{customLabel.cu_type || "客户分类"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_type}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_bankaccount" slot="cu_bankaccount">
            <label class="weui-form-preview__label">{{customLabel.cu_bankaccount || "开户银行"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_bankaccount}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_bankcode" slot="cu_bankcode">
            <label class="weui-form-preview__label">{{customLabel.cu_bankcode || "开户账号"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_bankcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_invoiceinfo" slot="cu_invoiceinfo">
            <label class="weui-form-preview__label">{{customLabel.cu_invoiceinfo || "开票地址"}}</label>
            <span class="weui-form-preview__value" :class="{'weui-form-preview__value-icon': !!form.main.cu_invoiceinfo,}">
              {{form.main.cu_invoiceinfo}}
              <router-link
                v-if="form.main.cu_invoiceinfo"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.cu_invoiceinfo"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_legal_person">
            <label class="weui-form-preview__label">{{customLabel.cu_legal_person || "法人"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_legal_person}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_uu">
            <label class="weui-form-preview__label">{{customLabel.cu_uu || "UU"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_uu}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_payments">
            <label class="weui-form-preview__label">{{customLabel.cu_payments || "收款方式"}}</label>
            <span class="weui-form-preview__value">
              {{form.main.cu_payments}}
              <span v-if="form.main.cu_currency">{{form.main.cu_currency}}</span>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_taxrate">
            <label class="weui-form-preview__label">{{customLabel.cu_taxrate || "税率(%)"}}</label>
            <span class="weui-form-preview__value">{{form.main.cu_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.cu_sellername" slot="cu_sellername">
            <label class="weui-form-preview__label">{{customLabel.cu_sellername || "业务员"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.cu_sellername}}
              <call-mobile :em-id="form.main.cu_sellerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cu_leftamount">
            <label class="weui-form-preview__label">{{customLabel.cu_leftamount || "应收余额(元)"}}</label>
            <span
              class="weui-form-preview__value"
              v-format="'¥#,##0.00'"
            >{{form.main.cu_leftamount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_credit">
            <label class="weui-form-preview__label">{{customLabel.cu_credit || "信用额度"}}</label>
            <span
              class="weui-form-preview__value"
              v-format="'¥#,##0.00'"
            >{{form.main.cu_credit}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cu_remark">
            <label class="weui-form-preview__label">{{customLabel.cu_remark || "备注"}}</label>
            <span
              class="weui-form-preview__value"
            >{{form.main.cu_remark}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.cu_text1 || '自定义字段1'"
          v-model="form.main.cu_text1" slot="cu_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.cu_text2 || '自定义字段2'"
          v-model="form.main.cu_text2" slot="cu_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.cu_text3 || '自定义字段3'"
          v-model="form.main.cu_text3" slot="cu_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.cu_text4 || '自定义字段4'"
          v-model="form.main.cu_text4" slot="cu_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.cu_text5 || '自定义字段5'"
          v-model="form.main.cu_text5" slot="cu_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
        <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="cc_name">
            <label class="weui-form-preview__label">{{customLabel.cc_name || "代理商联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{item.cc_name}} {{item.cc_tel}}
              <call-mobile :mobile="item.cc_tel"></call-mobile>
            </span>
          </div>
        </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
        <custom-layout :view-config="customViewConfig" position="detail2">
          <div class="weui-form-preview__item" slot="ca_address">
            <label class="weui-form-preview__label">{{customLabel.ca_address || "送货地址"}}</label>
            <span class="weui-form-preview__value" :class="{'weui-form-preview__value-icon': !!item.ca_address,}">
              {{item.ca_address}}
              <router-link
                v-if="item.ca_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + item.ca_address"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ca_phone">
            <label class="weui-form-preview__label">{{customLabel.ca_phone || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{item.ca_person}} {{item.ca_phone}}
              <call-mobile :mobile="item.ca_phone"></call-mobile>
            </span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.ca_text1 || '自定义字段1'"
          v-model="item.ca_text1" slot="ca_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ca_text2 || '自定义字段2'"
          v-model="item.ca_text2" slot="ca_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ca_text3 || '自定义字段3'"
          v-model="item.ca_text3" slot="ca_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ca_text4 || '自定义字段4'"
          v-model="item.ca_text4" slot="ca_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ca_text5 || '自定义字段5'"
          v-model="item.ca_text5" slot="ca_text5" hidden="true" />
        </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/document/agent_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
      >反审</a>
      <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_default" @click="f_remove">删除</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/customer",
      codeField: "cu_code",
      statusField: "cu_audit_status_code",
      caller: "Customer",
      xtype:'agent-agentinfo-formpanel',
      form: {
        main: {},
        items1: [],
        items2: []
      }
    };
  }
};
</script>